import React, { useCallback, useState } from "react";
import PrimaryButton from "../../Buttons/PrimaryButton";
import TertiaryButton from "../../Buttons/TertiaryButton";
import CrossButton from "../../CrossButton/CrossButton";
import crossBlack from "../../../assets/images/blackCrossIcon.svg";

const ReactivateSubscriptionPopup = ({ popupData, closePopup }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isCancelled, setIsCancelled] = useState(true);

  const onSave = useCallback(async () => {
    if (popupData?.handleSubmit) {
      setIsLoading(true);
      await popupData.handleSubmit();
      setIsCancelled(false);
      setIsLoading(false);
    }
  }, [popupData]);

  return (
    <div className="p-8" style={{ width: popupData?.popupWidth }}>
      <div className="flex justify-end">
        <CrossButton
          onClick={closePopup}
          icon={crossBlack}
          style={{ height: "12.73px", width: "12.73px" }}
        />
      </div>
      <div className="text-center text-es-lg text-es-dark-grey p-2 mb-4">
        {isCancelled
          ? "Your subscription will be reactivated immediately"
          : "Your subscription was successfully reactivated!"}
      </div>
      {isCancelled && (
        <div className="flex justify-center">
          <PrimaryButton
            onClick={onSave}
            border="es-green"
            background="es-green"
            fontColor="white"
            name="primaryButton"
            title="Reactivate"
            className="text-base"
            disabled={isLoading}
          />
          <div className="ml-2">
            <TertiaryButton
              title="cancel"
              onClick={closePopup}
              border="es-green"
              background="white"
              fontColor="es-green"
              name="primaryButton"
              className="text-base"
            />
          </div>
        </div>
      )}
      {!isCancelled && (
        <div className="flex justify-center">
          <PrimaryButton
            onClick={closePopup}
            border="es-green"
            background="es-green"
            fontColor="white"
            name="primaryButton"
            title="Ok"
            className="text-base"
            disabled={isLoading}
          />
        </div>
      )}
    </div>
  );
};

export default ReactivateSubscriptionPopup;
